var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 15,
    viewBox: "0 0 30 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21279_163193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39998 13.3H14.2L17.3 1.69995H7.39998C4.19998 1.69995 1.59998 4.29995 1.59998 7.49995C1.59998 10.7 4.19998 13.3 7.39998 13.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6 0.5H7.40002C3.50002 0.5 0.400024 3.6 0.400024 7.5C0.400024 11.4 3.50002 14.5 7.40002 14.5H22.6C26.5 14.5 29.6 11.4 29.6 7.5C29.6 3.6 26.4 0.5 22.6 0.5ZM1.60002 7.5C1.60002 4.3 4.20002 1.7 7.40002 1.7H17.3L14.2 13.3H7.40002C4.20002 13.3 1.60002 10.7 1.60002 7.5Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6001 4.5001C24.8001 4.7001 24.8001 5.1001 24.6001 5.3001L22.5001 7.5001L24.7001 9.7001C24.9001 9.9001 24.9001 10.3001 24.7001 10.5001C24.5001 10.7001 24.1001 10.7001 23.9001 10.5001L21.7001 8.3001L19.5001 10.5001C19.3001 10.7001 18.9001 10.7001 18.7001 10.5001C18.5001 10.3001 18.5001 9.9001 18.7001 9.7001L20.8001 7.5001L18.6001 5.3001C18.4001 5.1001 18.4001 4.7001 18.6001 4.5001C18.8001 4.3001 19.2001 4.3001 19.4001 4.5001L21.6001 6.7001L23.8001 4.5001C24.0001 4.3001 24.4001 4.3001 24.6001 4.5001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 4.59995C12.9 4.79995 13 5.19995 12.8 5.39995L8.6 10.3C8.5 10.4 8.4 10.5 8.3 10.5C8.1 10.6 7.8 10.6 7.6 10.4L5.4 8.19995C5.2 7.99995 5.2 7.59995 5.4 7.39995C5.6 7.19995 6 7.19995 6.2 7.39995L8 9.09995L11.8 4.59995C12 4.39995 12.4 4.39995 12.7 4.59995Z",
    fill: "#0066FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21279_163193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyIcon);
export default __webpack_public_path__ + "static/media/privacy-icon.883aac5089f77832b5dac395d1de758b.svg";
export { ForwardRef as ReactComponent };